import type {ReactElement} from 'react';
import React from 'react';
import useDefaultPanelClose from '@Panels/hooks/useDefaultPanelClose';
import PosterEditorColorPanel from '@Panels/poster-editor-color-panel';
import type {RGBA} from '@Utils/color.util';
import {FillTypes} from '@PosterWhiteboard/classes/fill.class';
import {updateLastDrawBrushColor} from '@Components/poster-editor/library/poster-editor-library';
import {useAppSelector} from '@/hooks';

interface PosterEditorDrawBrushColorPanelProps {
  panelId: string;
}

export default function PosterEditorDrawBrushColorPanel({...props}: PosterEditorDrawBrushColorPanelProps): ReactElement | null {
  const onClose = useDefaultPanelClose(props.panelId);
  const color = useAppSelector((state) => {
    return state.posterEditor.posterObject?.drawing.drawBrush?.strokeColor;
  });

  if (!color) {
    return null;
  }

  const updateColor = (updatedColor: RGBA): void => {
    window.posterEditor?.whiteboard?.drawing.updateDrawModeColor(updatedColor);
    updateLastDrawBrushColor(updatedColor);
  };

  const onChangeColor = (updatedColor: RGBA[]): void => {
    updateColor(updatedColor[0]);
  };

  const getColorPanel = (): ReactElement => {
    return (
      <PosterEditorColorPanel
        panelId={props.panelId}
        fillObject={{
          fillColor: [color],
          fillType: FillTypes.SOLID,
        }}
        onChangeColor={onChangeColor}
        onClose={onClose}
        showInitialBackButton={false}
      />
    );
  };

  return getColorPanel();
}
